
export enum DisplayState {
    Minimized,
    FullScreen
}
